// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3dOC-","info":"UpdateTermsInfo_info__3sG2K"};